import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import ButtonBase from './ButtonBase';

import './styles/linkButtonStyles.css';

const typeStyles = {
  primary: 'link-primary',
  secondary: 'link-secondary',
  subtle: 'link-subtle',
  tertiary: 'link-tertiary',
};

const RouterLinkButton = ({ children, disabled, to, type, ...rest }) => {
  const style = typeStyles[type] || '';

  return disabled ? (
    <ButtonBase className={style} disabled onClick={() => {}} {...rest}>
      {children}
    </ButtonBase>
  ) : (
    <Link className={style} to={to} {...rest}>
      {children}
    </Link>
  );
};

RouterLinkButton.propTypes = {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  to: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['primary', 'secondary', 'subtle', 'tertiary'])
    .isRequired,
};

RouterLinkButton.defaultProps = {
  disabled: false,
};
export default RouterLinkButton;
